import { services } from './services'
import { stores } from './stores'

export const modal: {
  meta: {
    name: 'modal'
  }
  layers: {
    stores: typeof stores
    services: typeof services
  }
} = {
  meta: {
    name: 'modal',
  },
  layers: {
    services,
    stores,
  },
}
